import { render, staticRenderFns } from "./proof-details.vue?vue&type=template&id=4ca12b26&scoped=true&"
import script from "./proof-details.vue?vue&type=script&lang=js&"
export * from "./proof-details.vue?vue&type=script&lang=js&"
import style0 from "./proof-details.vue?vue&type=style&index=0&id=4ca12b26&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca12b26",
  null
  
)

export default component.exports